import {ShareOutlined} from "@material-ui/icons";

export default function ShareButton() {
    return (
        <div className="post__share">
            <ShareOutlined/>
        </div>
    )
}
